import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import { useDispatch } from 'react-redux'
import request from '@/modules/base/util/request'
import settingsConfig from '@/modules/settings/config'
import { fetchData } from '@/redux/ducks/settings/letterPaper'
import LetterPaperLayout from '@/modules/letter-paper-settings/letter-paper-layout/letter-paper-layout'
import LetterPaperLayoutPreview from '@/modules/letter-paper-settings/letter-paper-layout/letter-paper-layout-preview'

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    flexDirection: 'column',
  },
}))

const LayoutData = forwardRef(({ onSubmitted, onValid, onLetterPaperIdChange }, ref) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [letterPaperSettings, setLetterPaperSettings] = useState<any>(null)
  const [layoutId, setLayoutId] = useState<string | undefined>()
  const [layoutItems, setLayoutItems] = useState<any>(null)
  const layoutRef = useRef()

  const handleSetLayoutId = (newId: string) => {
    setLayoutId(newId)

  }

  useImperativeHandle(ref, () => ({
    save: async() => {
      if (layoutRef.current && layoutId) {
        layoutRef.current.saveSelectedDefault().then(() => {
          if (onLetterPaperIdChange) {
            onLetterPaperIdChange(layoutId)
          }
          onSubmitted()
        })
      } else {
        onSubmitted()
      }
    },
  }))

  useEffect(() => {
    onValid(true)
  }, [])

  useEffect(() => {
    dispatch(fetchData())
    request(settingsConfig.getLetterPaper, {
      method: 'GET',
      auth: true,
      isConcurrent: true,
    }).then((result) => {
      const {
        body: { data },
      } = result
      setLetterPaperSettings(data)
    })
  }, [dispatch])

  // TODO hide standard button
  // TDOD forwaord ref to save
  return (
    <div className={classes.wrapper}>
      <LetterPaperLayout
        letterPaperSettings={letterPaperSettings}
        setSelectedLayoutId={handleSetLayoutId}
        setThumbnailLayoutItems={setLayoutItems}
        isOnboardingTester
        ref={layoutRef}
      />
      <LetterPaperLayoutPreview
        layoutId={layoutId}
        layoutItems={layoutItems}
        isOnboardingTester
      />
    </div>
  )
})

LayoutData.propTypes = {
  onLetterPaperIdChange: PropTypes.func,
}

export default LayoutData

interface LayoutProps {
  letterPaperSettings?: any
  onLetterPaperIdChange?: (layoutId: string) => void
}
